import React from 'react'
interface StatusReturnsIconProps {
  size?: number
  color?: string
  strokeWidth?: number
  className?: string
}

export function StatusReturnsIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
}: StatusReturnsIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Outer circle */}
      <circle cx="12" cy="12" r="10" />
      {/* Return arrow - counterclockwise */}
      <path d="M8 12c0-2.2 1.8-4 4-4s4 1.8 4 4" />
      <path d="M12 8v2.5" />
      <path d="M13.5 8.5l-1.5-2.5-1.5 2.5" />
    </svg>
  )
}
